import { WarmupWarmdownConfig } from '../../config/WarmupwarmdownConfig';
import { Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';
export class FilterOutNonExerciseFilter implements IExerciseSelectionFilter {
    public description: string = 'Return only exercises';
    public name: string = 'filterOutNonExerciseFilter';

    public filter(inputExercises: Exercise[]): Exercise[] {
        return inputExercises.filter((singleItem: Exercise) => {
            return singleItem.exerciseFormats.filter((format) => {
                return !WarmupWarmdownConfig.isWarmupOrWarmdown(format);
            }).length > 0;
        });
    }
}
